import { render } from "./index.vue?vue&type=template&id=a1ca6ea4&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=a1ca6ea4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1ca6ea4"]])

export default __exports__